require('./Button_WatchOnline.scss');
require('../../Icon/Icon.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_S.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_M.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_L.scss');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Button = require('app/www/components/blocks/Button/Button');
const ButtonWrapper = require('app/www/components/blocks/ButtonWrapper/ButtonWrapper');
const Global = require('app/www/components/blocks/Global/Global');
const Metrika = require('app/www/libs/client/metrika');
const OttWidget = require('app/www/components/blocks/OttWidget/OttWidget');
const Ua = require('app/www/components/blocks/Ua/Ua');

class Button_WatchOnline extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            widget: false,
        };

        this._showButton = Global.isRussia && !Ua.isOldOpera && !Ua.isOldIE;

        this._onClick = this._onClick.bind(this);
        this._onCloseWidget = this._onCloseWidget.bind(this);
    }

    componentDidMount() {
        if (this._showButton) {
            this._sendMetrika('show');
        }
    }

    render() {
        if (!this._showButton) {
            return null;
        }

        const {
            i18n,
            children,
            fromBlock,
            ottSelection,
        } = this.props;

        const buttonWrapperProps = {
            mods: {
                active: this.state.widget,
            },
        };

        const buttonProps = Object.assign({}, this.props, {
            onClick: this._onClick,
            children: children || i18n.get('button.watchOnline'),
        });

        const widgetProps = {
            contentGroupUuid: ottSelection.contentGroupUuid,
            selectionId: ottSelection.selectionId,
            fromBlock,
            onClose: this._onCloseWidget,
        };

        return (
            <ButtonWrapper {...buttonWrapperProps}>
                <Button
                    ref={ref => (this.button = ref)}
                    {...buttonProps}
                />
                {this.state.widget && (
                    <OttWidget {...widgetProps} />
                )}
            </ButtonWrapper>
        );
    }

    /**
     * Обработчик нажатия на кнопку
     * @private
     */
    _onClick(evt) {
        evt.preventDefault();

        this.setState({
            widget: true,
        });

        this.props.onClick();
        this._sendMetrika('click');
    }

    /**
     * Отправляем данные в метрику
     * @param {String} action show|click
     * @private
     */
    _sendMetrika(action) {
        const {eventId, programId} = this.props;

        Metrika.trackParams('PROGRAM_PAGE', {
            component: 'button_online',
            action,
            programId,
            eventId,
        });
    }

    /**
     * Закрываем виджет
     * @private
     */
    _onCloseWidget() {
        this.setState({
            widget: false,
        });
    }

}

Button_WatchOnline.defaultProps = {
    onClick: () => {},
};

Button_WatchOnline.propTypes = {
    mods: Button.propTypes.mods,
    fromBlock: PropTypes.string,
    ottSelection: PropTypes.shape({
        selectionId: PropTypes.number,
        contentGroupUuid: PropTypes.string,
    }),
    onClick: PropTypes.func,
};

module.exports = withI18n(Button_WatchOnline);
